/* eslint-disable no-param-reassign */
import { produce } from 'immer';
import _filter from 'lodash/filter';
import _reduce from 'lodash/reduce';
import _find from 'lodash/find';
import logNewRelicCustom from '../../../utils/logNewRelicCustom';
import { _initialState } from '../_initialState';
import { NEW_RELIC_EVENTS } from '../../../constants';

export default (set, get, id, bundleId = null) => set(
  produce(get(), (draft) => {
    if (!draft.design) {
      draft.design = {};
    }

    const productsState = get().design.products;
    const bundlesAddedState = get().bundles.added;

    if (bundleId) {
      const updatedProductsState = _reduce(
        productsState,
        (prev, curr) => {
          if (curr.stackItemId !== id) {
            prev.push({
              ...curr,
              choiceBundle: curr?.choiceBundle?.id === bundleId
                ? null
                : curr.choiceBundle
            });
          }
          return prev;
        },
        []
      );
      const filteredBundlesAdded = _filter(
        bundlesAddedState,
        (bundleAdded) => bundleAdded.bundleId !== bundleId
      );

      draft.bundles.added = filteredBundlesAdded;
      draft.design.products = updatedProductsState;
      draft.design.selectedProduct = null;
      logNewRelicCustom(NEW_RELIC_EVENTS.BUNDLE_PRODUCT_REMOVED, { bundleId });
      return draft;
    }

    const target = _find(productsState, (item) => item.stackItemId === id);

    draft.design.products = _filter(
      productsState,
      (stackItem) => stackItem.stackItemId !== id
    );
    draft.design.selectedProduct = null;

    const enhancedTarget = {
      ...target,
      ...(draft.design?.isFromPip && { isFromPip: true })
    };

    logNewRelicCustom(NEW_RELIC_EVENTS.PRODUCT_REMOVED, enhancedTarget);
    return draft;
  }),
  false,
  { type: 'REMOVE', id }
);
